{
  "COMPOSE_REDIRECT": {
    "OPENING": "Otwieranie nowej rozmowy z {email}…",
    "NO_EMAIL": "Nie podano adresu e-mail. Użyj ?email=name@example.com",
    "CONTACT_ERROR": "Nie udało się znaleźć kontaktu dla {email}."
  },
  "CONVERSATION": {
    "404": "Przepraszamy, nie można odnaleźć konwersacji. Spróbuj ponownie",
    "IMAGE_RESIZE": {
      "SMALL": "Mały",
      "MEDIUM": "Średni",
      "LARGE": "Duży",
      "ORIGINAL": "Oryginalny"
    },
    "SHOW_HIDDEN_MESSAGES": "Pokaż ukryte wiadomości",
    "SELECT_A_CONVERSATION": "Wybierz konwersację z lewego panelu",
    "CSAT_REPLY_MESSAGE": "Oceń konwersację",
    "SWITCH_VIEW_LAYOUT": "Zmień układ",
    "DASHBOARD_APP_TAB_MESSAGES": "Wiadomości",
    "UNVERIFIED_SESSION": "Tożsamość tego użytkownika nie jest zweryfikowana",
    "NO_MESSAGE_1": "Ups! Wygląda na to, że nie ma wiadomości od klientów w Twojej skrzynce odbiorczej.",
    "NO_MESSAGE_2": " aby wysłać wiadomość na swoją stronę!",
    "NO_INBOX_1": "Hola! Wygląda na to, że nie dodałeś jeszcze żadnej skrzynki odbiorczej.",
    "NO_INBOX_2": " aby rozpocząć",
    "NO_INBOX_AGENT": "Uh Oh! Wygląda na to, że nie jesteś częścią żadnej skrzynki odbiorczej. Skontaktuj się z administratorem",
    "SEARCH_MESSAGES": "Szukaj wiadomości w konwersacjach",
    "VIEW_ORIGINAL": "View original",
    "VIEW_TRANSLATED": "View translated",
    "TRANSLATION": "Tłumaczenie",
    "EMPTY_STATE": {
      "CMD_BAR": "to open command menu",
      "KEYBOARD_SHORTCUTS": "to view keyboard shortcuts"
    },
    "SEARCH": {
      "TITLE": "Szukaj wiadomości",
      "RESULT_TITLE": "Wyniki wyszukiwania",
      "LOADING_MESSAGE": "Trwa przetwarzanie danych...",
      "PLACEHOLDER": "Wpisz dowolny tekst, aby wyszukać wiadomości",
      "NO_MATCHING_RESULTS": "Brak wyników."
    },
    "TRANSCRIPT": {
      "SHOW": "Pokaż pełen transkrypt",
      "HIDE": "Ukryj pełen transkrypt",
      "DOWNLOAD": "Pobierz transkrypt",
      "COPY": "Kopiuj transkrypt"
    },
    "INVISIBLE_TO_CUSTOMER": "Niewidoczne dla klienta",
    "SENT_VIA_EMAIL": "Wysłano do kontaktu także e-mailem ({time})",
    "UNREAD_MESSAGES": "Nieprzeczytane wiadomości",
    "UNREAD_MESSAGE": "Nieprzeczytana wiadomość",
    "CLICK_HERE": "Kliknij tutaj",
    "LOADING_INBOXES": "Ładowanie skrzynek odbiorczych",
    "LOADING_CONVERSATIONS": "Ładowanie konwersacji",
    "CANNOT_REPLY": "Nie możesz odpowiedzieć z powodu",
    "24_HOURS_WINDOW": "Ograniczenie 24-godzinnego okna wiadomości",
    "API_HOURS_WINDOW": "Możesz odpowiedzieć na tę rozmowę tylko w ciągu {hours} godzin",
    "FACEBOOK_CANNOT_REPLY": "Jeśli chcesz kontynuować tę rozmowę, ",
    "NOT_ASSIGNED_TO_YOU": "Ta konwersacja nie jest Ci przypisana. Czy chcesz przypisać tę konwersację do siebie?",
    "ASSIGN_TO_ME": "Przypisz do mnie",
    "PENDING_WITH_BOT_BANNER": "Ta rozmowa jest obsługiwana przez bota AI. Jeśli chcesz odpowiedzieć, najpierw otwórz rozmowę.",
    "INBOX_DELETE_REQUESTED_BANNER": "Ta skrzynka odbiorcza jest oznaczona do usunięcia, więc odpowiedź klienta nigdy by nie dotarła. Aby odpowiedzieć, przenieś konwersację do innej skrzynki odbiorczej.",
    "OPEN_CONVERSATIONS_BANNER": {
      "SINGLE": "Ten kontakt ma inną otwartą rozmowę #{id}",
      "MULTIPLE": "Ten kontakt ma inne otwarte rozmowy ({count})",
      "OPEN": "Otwórz",
      "SHOW": "Pokaż"
    },
    "TWILIO_WHATSAPP_CAN_REPLY": "Możesz odpowiedzieć na tę rozmowę tylko za pomocą szablonu wiadomości, ponieważ",
    "TWILIO_WHATSAPP_24_HOURS_WINDOW": "Ograniczenie 24-godzinnego okna wiadomości",
    "OLD_INSTAGRAM_INBOX_REPLY_BANNER": "To konto Instagram zostało przeniesione do nowej skrzynki odbiorczej kanału Instagram. Wszystkie nowe wiadomości będą się tam pojawiać. Nie można już wysyłać wiadomości z tej rozmowy.",
    "WEB_WIDGET_OFFLINE_MESSAGE": "Nie można wysłać wiadomości, ponieważ klient jest offline, a ciągłość e-mail nie jest dostępna.",
    "WEB_WIDGET_OFFLINE_WARNING_MESSAGE": "Klient jest offline. Może nie otrzymać wiadomości, ponieważ ciągłość e-mail nie jest dostępna.",
    "REPLYING_TO": "Osoba, której odpowiadasz to:",
    "REMOVE_SELECTION": "Usuń zaznaczenie",
    "DOWNLOAD": "Pobierz",
    "OPEN_FILE": "Otwórz",
    "DOWNLOAD_ATTACHMENTS": "Pobierz wszystkie",
    "DOWNLOAD_ATTACHMENTS_TOOLTIP": "Pobierz wszystkie załączniki pojedynczo",
    "DOWNLOAD_ATTACHMENTS_AS_ZIP": "Pobierz wszystkie jako ZIP",
    "ERROR_DOWNLOADING_FILE": "Błąd pobierania pliku",
    "UNKNOWN_FILE_TYPE": "Nieznany plik",
    "SAVE_CONTACT": "Save Contact",
    "NO_CONTENT": "No content to display",
    "COPILOT_ASSUMED_ACTIONS": {
      "TITLE": "Przed wysłaniem wykonaj:",
      "EXECUTE": "Wykonaj",
      "RETRY": "Spróbuj ponownie",
      "CONFIRM": "Wykonać teraz?",
      "CONFIRM_YES": "Tak, wykonaj",
      "CONFIRM_NO": "Anuluj",
      "RUNNING": "W toku…",
      "DONE": "Wykonano",
      "CLAIM_DELAYED": "zostanie złożona po doręczeniu zamówienia",
      "DEVIATIONS": {
        "CLAIM_CLOSED": "Utworzono NOWĄ reklamację {reference}, ponieważ {planned} jest zamknięta — zmień tekst wersji roboczej",
        "NEW_CLAIM": "Utworzono NOWĄ reklamację {reference} zamiast zaktualizować {planned} — zmień tekst wersji roboczej",
        "OTHER_CLAIM": "Zaktualizowano reklamację {reference} zamiast {planned} — zmień tekst wersji roboczej",
        "EXISTING_CLAIM": "Nie utworzono nowej reklamacji, zaktualizowano istniejącą {reference} — zmień tekst wersji roboczej",
        "OTHER": "Przebiegło to inaczej, niż zakładała wersja robocza — zmień jej tekst"
      },
      "FAILED": "Nie powiodło się",
      "UNREACHABLE": "Bot jest niedostępny",
      "REQUEST_FAILED": "Nie udało się uruchomić akcji, spróbuj ponownie.",
      "ACTIONS": {
        "CANCEL_ORDER": "Anuluj zamówienie",
        "CHANGE_ORDER_PAYMENT_TO_COD": "Zmień formę płatności na pobranie",
        "CREATE_CLAIM": "Złóż reklamację",
        "CREATE_OR_UPDATE_CLAIM": "Złóż lub zaktualizuj reklamację",
        "EXTEND_ORDER_PICKUP_DATE": "Przedłuż termin odbioru"
      }
    },
    "SHARED_ATTACHMENT": {
      "CONTACT": "{sender} has shared a contact",
      "LOCATION": "{sender} has shared a location",
      "FILE": "{sender} has shared a file"
    },
    "UPLOADING_ATTACHMENTS": "Przesyłanie załączników...",
    "REPLIED_TO_STORY": "Odpowiedziałeś na swoją historię",
    "UNSUPPORTED_MESSAGE": "This message is unsupported. You can view this message on the Facebook / Instagram app.",
    "UNSUPPORTED_MESSAGE_FACEBOOK": "This message is unsupported. You can view this message on the Facebook Messenger app.",
    "UNSUPPORTED_MESSAGE_INSTAGRAM": "This message is unsupported. You can view this message on the Instagram app.",
    "SUCCESS_DELETE_MESSAGE": "Wiadomość usunięta pomyślnie",
    "FAIL_DELETE_MESSSAGE": "Nie można usunąć wiadomości! Spróbuj ponownie",
    "NO_RESPONSE": "Brak odpowiedzi",
    "REQUEST_CONTACT_INFO": {
      "ACTION": "Poproś klienta o podanie numeru telefonu WhatsApp",
      "PENDING_ACTION": "Prośba o dane kontaktowe oczekuje na odpowiedź",
      "STATES": {
        "PENDING": "Oczekiwanie na dane kontaktowe",
        "SHARED": "Numer telefonu udostępniony",
        "IDENTITY_CONFLICT": "Numer telefonu wymaga sprawdzenia"
      }
    },
    "RESPONSE": "Response",
    "RATING_TITLE": "Ocena",
    "FEEDBACK_TITLE": "Opinia",
    "REPLY_MESSAGE_NOT_FOUND": "Message not available",
    "CARD": {
      "SHOW_LABELS": "Pokaż etykiety",
      "HIDE_LABELS": "Ukryj etykiety"
    },
    "HEADER": {
      "MORE": "Więcej akcji",
      "RESOLVE_ACTION": "Rozwiąż",
      "REOPEN_ACTION": "Otwórz ponownie",
      "OPEN_ACTION": "Otwórz",
      "OPEN": "Więcej",
      "CLOSE": "Zamknij",
      "DETAILS": "szczegóły",
      "SNOOZED_UNTIL": "Uśpione do",
      "SNOOZED_UNTIL_TOMORROW": "Uśpij do jutra",
      "SNOOZED_UNTIL_NEXT_WEEK": "Uśpione do następnego tygodnia",
      "SNOOZED_UNTIL_NEXT_REPLY": "Uśpione do następnej odpowiedzi",
      "SLA_STATUS": {
        "FRT": "FRT {status}",
        "NRT": "NRT {status}",
        "RT": "RT {status}",
        "MISSED": "missed",
        "DUE": "due"
      }
    },
    "RESOLVE_DROPDOWN": {
      "MARK_PENDING": "Oznacz jako oczekujące",
      "SNOOZE_UNTIL": "Uśpij",
      "RESOLVE_WITHOUT_CSAT": "Zamknij bez CSAT",
      "SNOOZE": {
        "TITLE": "Uśpij do",
        "NEXT_REPLY": "Następna odpowiedź",
        "TOMORROW": "Jutro",
        "NEXT_WEEK": "Następny tydzień"
      }
    },
    "CUSTOM_SNOOZE": {
      "TITLE": "Uśpij do",
      "APPLY": "Uśpij",
      "CANCEL": "Anuluj"
    },
    "PRIORITY": {
      "TITLE": "Priorytet",
      "OPTIONS": {
        "NONE": "Brak",
        "URGENT": "Pilne",
        "HIGH": "Wysoki",
        "MEDIUM": "Średni",
        "LOW": "Niski"
      },
      "CHANGE_PRIORITY": {
        "SELECT_PLACEHOLDER": "Brak",
        "INPUT_PLACEHOLDER": "Wybierz priorytet",
        "NO_RESULTS": "Brak wyników",
        "SUCCESSFUL": "Zmieniono priorytet konwersacji o identyfikatorze {conversationId} na {priority}",
        "FAILED": "Nie można zmienić priorytetu. Spróbuj ponownie."
      }
    },
    "SLA": {
      "BREACHED": "naruszone"
    },
    "CARD_CONTEXT_MENU": {
      "OPEN_IN_NEW_TAB": "Otwórz w nowej karcie",
      "COPY_LINK": "Kopiuj link do rozmowy",
      "COPY_LINK_SUCCESS": "Link do rozmowy skopiowany do schowka",
      "PENDING": "Oznacz jako oczekujące",
      "RESOLVED": "Oznacz jako rozwiązane",
      "MARK_AS_UNREAD": "Oznacz jako nieprzeczytane",
      "MARK_AS_READ": "Mark as read",
      "REOPEN": "Otwórz ponownie",
      "SNOOZE": {
        "TITLE": "Uśpij",
        "NEXT_REPLY": "Do następnej odpowiedzi",
        "TOMORROW": "Do jutra",
        "NEXT_WEEK": "Do następnego tygodnia"
      },
      "ASSIGN_AGENT": "Przypisz Agenta",
      "ASSIGN_LABEL": "Przypisz etykietę",
      "AGENTS_LOADING": "Ładowanie agentów...",
      "ASSIGN_TEAM": "Przypisz zespół",
      "API": {
        "AGENT_ASSIGNMENT": {
          "SUCCESFUL": "Konwersacja o identyfikatorze {conversationId} przypisana do \"{agentName}\"",
          "FAILED": "Nie można przypisać agenta. Spróbuj ponownie."
        },
        "LABEL_ASSIGNMENT": {
          "SUCCESFUL": "Assigned label #{labelName} to conversation id {conversationId}",
          "FAILED": "Nie można przypisać etykiety. Spróbuj ponownie."
        },
        "TEAM_ASSIGNMENT": {
          "SUCCESFUL": "Przypisano zespół \"{team}\" do konwersacji o identyfikatorze {conversationId}",
          "FAILED": "Nie można przypisać zespołu. Spróbuj ponownie."
        }
      }
    },
    "FOOTER": {
      "MESSAGE_SIGN_TOOLTIP": "Podpis wiadomości",
      "ENABLE_SIGN_TOOLTIP": "Włącz podpis",
      "DISABLE_SIGN_TOOLTIP": "Wyłącz podpis",
      "INSERT_SIGNATURE": "Wstaw podpis do edytora",
      "SIGNATURE_PREVIEW_IMAGE": "(podpis obrazkowy)",
      "MSG_INPUT": "Shift + enter dla nowej linii. Zacznij od '/' aby wybrać Gotową odpowiedź.",
      "PRIVATE_MSG_INPUT": "Shift + enter dla nowej linii. Będzie widoczne tylko dla agentów",
      "MESSAGE_SIGNATURE_NOT_CONFIGURED": "Podpis wiadomości nie jest skonfigurowany, należy go skonfigurować w ustawieniach profilu.",
      "CLICK_HERE": "Kliknij tutaj, aby zaktualizować",
      "WHATSAPP_TEMPLATES": "Szablony WhatsApp",
      "WHATSAPP_TEMPLATE_ONLY_INPUT": "24-godzinne okno WhatsApp wygasło. Odpowiedz za pomocą szablonu."
    },
    "REPLYBOX": {
      "LANGUAGE_MISMATCH": "Twoja odpowiedź wydaje się być w języku {draftLanguage}, ale ta rozmowa jest w języku {conversationLanguage}.",
      "TRANSLATE_DRAFT": "Przetłumacz",
      "REPLY": "Odpowiedz",
      "PRIVATE_NOTE": "Notatka prywatna",
      "SEND": "Wyślij",
      "SEND_EMAIL": "Wyślij e-mail",
      "SEND_SMS": "Wyślij SMS",
      "NO_SMS_INBOX": "Dodaj skrzynkę odbiorczą SMS, aby wysyłać odpowiedzi SMS.",
      "SEND_CHAT": "Wyślij wiadomość",
      "CREATE": "Dodaj notatkę",
      "INSERT_READ_MORE": "Czytaj więcej",
      "DISMISS_REPLY": "Dismiss reply",
      "REPLYING_TO": "Replying to:",
      "REPLY_TO_THIS": "Odpowiedz na to",
      "TIP_EXPAND_ICON": "Powiększ edytor",
      "TIP_COLLAPSE_ICON": "Zmniejsz edytor",
      "TIP_FORMAT_ICON": "Pokaż zaawansowany edytor",
      "HEADING_LEVEL": {
        "LABEL": "Styl tekstu",
        "NORMAL": "Tekst normalny",
        "H1": "Nagłówek 1",
        "H2": "Nagłówek 2",
        "H3": "Nagłówek 3"
      },
      "EDITOR": {
        "BOLD": "Pogrubienie",
        "ITALIC": "Kursywa",
        "UNDERLINE": "Podkreślenie",
        "TEXT_COLOR": "Kolor tekstu",
        "BG_COLOR_LABEL": "Kolor tła",
        "FONT_SIZE_LABEL": "Rozmiar czcionki",
        "FONT_SIZE": {
          "XS": "Mały",
          "SM": "Średnio mały",
          "MD": "Domyślny",
          "LG": "Duży",
          "XL": "Bardzo duży",
          "XXL": "Ogromny"
        },
        "CODE": "Kod",
        "LINK": "Dodaj lub usuń link",
        "CREATE_LINK": "Utwórz link",
        "SAVE_LINK": "Zapisz",
        "CANCEL": "Anuluj",
        "LINK_PLACEHOLDER": "https://example.com",
        "UNDO": "Cofnij",
        "REDO": "Ponów",
        "BULLET_LIST": "Lista punktowana",
        "ORDERED_LIST": "Lista numerowana",
        "BLOCKQUOTE": "Cytat",
        "H1": "Nagłówek 1",
        "H2": "Nagłówek 2",
        "H3": "Nagłówek 3",
        "IMAGE_UPLOAD": "Prześlij obraz",
        "CLEAR_FORMATTING": "Wyczyść formatowanie",
        "COLOR": {
          "RED": "Czerwony",
          "YELLOW": "Żółty",
          "BLUE": "Niebieski",
          "ROSE_RED": "Różowoczerwony",
          "DEEP_CYAN": "Ciemny turkusowy",
          "ORANGE": "Pomarańczowy",
          "PISTACHIO": "Pistacjowy",
          "PURPLE": "Fioletowy",
          "FUCHSIA": "Fuksja",
          "SILVER": "Srebrny",
          "NAVY": "Granatowy",
          "OLD_PINK": "Stary róż",
          "AQUA": "Morski",
          "BROWN": "Brązowy",
          "OLIVE": "Oliwkowy",
          "GOLD": "Złoty",
          "BEIGE": "Beżowy",
          "WINE": "Bordowy",
          "FOREST": "Leśny zielony",
          "GREEN": "Zielony",
          "BLUE_GREY": "Niebieskoszary",
          "RUBY_RED": "Rubinowy",
          "CHESTNUT_BROWN": "Kasztanowy",
          "ASH_GREY": "Popielaty"
        },
        "BG_COLOR": {
          "RED": "Czerwony",
          "YELLOW": "Żółty",
          "BLUE": "Niebieski",
          "ROSE_RED": "Różowoczerwony",
          "DEEP_CYAN": "Ciemny turkusowy",
          "ORANGE": "Pomarańczowy",
          "PISTACHIO": "Pistacjowy",
          "PURPLE": "Fioletowy",
          "FUCHSIA": "Fuksja",
          "SILVER": "Srebrny",
          "NAVY": "Granatowy",
          "OLD_PINK": "Stary róż",
          "AQUA": "Morski",
          "BROWN": "Brązowy",
          "OLIVE": "Oliwkowy",
          "GOLD": "Złoty",
          "BEIGE": "Beżowy",
          "WINE": "Bordowy",
          "FOREST": "Leśny zielony",
          "GREEN": "Zielony",
          "BLUE_GREY": "Niebieskoszary",
          "RUBY_RED": "Rubinowy",
          "CHESTNUT_BROWN": "Kasztanowy",
          "ASH_GREY": "Popielaty"
        }
      },
      "TIP_EMOJI_ICON": "Pokaż selektor emotikonek",
      "TIP_ATTACH_ICON": "Dołącz pliki",
      "TIP_AUDIORECORDER_ICON": "Nagrywaj audio",
      "TIP_AUDIORECORDER_PERMISSION": "Zezwól na dostęp do dźwięku",
      "TIP_AUDIORECORDER_ERROR": "Nie można otworzyć dźwięku",
      "DRAG_DROP": "Przeciągnij i upuść tutaj, aby dołączyć",
      "START_AUDIO_RECORDING": "Rozpocznij nagrywanie audio",
      "STOP_AUDIO_RECORDING": "Zatrzymaj nagrywanie audio",
      "EMAIL_HEAD": {
        "EDIT": "Edytuj",
        "EXPAND": "DW/UDW",
        "HIDE": "Ukryj",
        "INCLUDE_ORIGINAL_MESSAGE": "Dołącz oryginalną wiadomość",
        "TO": "DO",
        "ADD_BCC": "Dodaj Bcc",
        "EDIT_HEADERS": "Edytuj",
        "HIDE_HEADER_EDITS": "Ukryj edycje",
        "CC": {
          "LABEL": "CC",
          "PLACEHOLDER": "Adresy e-mail oddzielone przecinkami",
          "ERROR": "Wprowadź poprawny adres e-mail"
        },
        "BCC": {
          "LABEL": "BCC",
          "PLACEHOLDER": "Adresy e-mail oddzielone przecinkami",
          "ERROR": "Wprowadź poprawny adres e-mail"
        },
        "SUBJECT": {
          "LABEL": "TEMAT",
          "PLACEHOLDER": "Temat e-maila",
          "RE_PREFIX": "Re:"
        }
      },
      "UNDEFINED_VARIABLES": {
        "TITLE": "Niezdefiniowane zmienne",
        "MESSAGE": "Masz {undefinedVariablesCount} niezdefiniowane zmienne w swojej wiadomości: {undefinedVariables}. Czy chcesz wysłać wiadomość mimo to?",
        "CONFIRM": {
          "YES": "Wyślij",
          "CANCEL": "Anuluj"
        }
      },
      "COPILOT": {
        "Q": "Zapytaj bota o pomoc"
      },
      "": ""
    },
    "VISIBLE_TO_AGENTS": "Prywatna uwaga: widoczne tylko dla Ciebie i Twojego zespołu",
    "CHANGE_STATUS": "Zmieniono status konwersacji",
    "CHANGE_STATUS_FAILED": "Nie udało się zmienić statusu konwersacji",
    "CHANGE_AGENT": "Zmieniono przypisaną osobę do konwersacji",
    "CHANGE_AGENT_FAILED": "Nie udało się zmienić przypisanej osoby",
    "ASSIGN_LABEL_SUCCESFUL": "Etykieta przypisana pomyślnie",
    "ASSIGN_LABEL_FAILED": "Nie udało się przypisać etykiety",
    "CHANGE_TEAM": "Zmieniono przypisany zespół konwersacji",
    "IMAGE_UPLOAD_ERROR": "Nie można przesłać obrazu, spróbuj ponownie",
    "FILE_SIZE_LIMIT": "Plik przekracza limit rozmiaru załącznika %{MAXIMUM_SUPPORTED_FILE_UPLOAD_SIZE} MB",
    "DRAFT": {
      "FILE_TOO_LARGE": "Plik \"{fileName}\" ({fileSize}) jest zbyt duży do zapisania w wersji roboczej i zostanie pominięty",
      "ATTACHMENT_SERIALIZATION_FAILED": "Nie udało się zserializować załącznika do zapisu wersji roboczej",
      "STORAGE_QUOTA_EXCEEDED": "Przekroczono limit przechowywania. Wersja robocza zapisana bez załączników",
      "SAVE_FAILED_WITHOUT_ATTACHMENTS": "Nie udało się zapisać wersji roboczej nawet bez załączników",
      "SAVE_FAILED": "Nie udało się zapisać wersji roboczej rozmowy"
    },
    "MESSAGE_ERROR": "Nie można wysłać tej wiadomości, spróbuj ponownie później",
    "SENT_BY": "Wysłane przez:",
    "BOT": "Bot",
    "SEND_FAILED": "Nie można wysłać wiadomości! Spróbuj ponownie",
    "TRY_AGAIN": "spróbuj ponownie",
    "ASSIGNMENT": {
      "SELECT_AGENT": "Wybierz Agenta",
      "REMOVE": "Usuń",
      "ASSIGN": "Przypisz"
    },
    "CONTEXT_MENU": {
      "COPY": "Kopiuj",
      "REPLY_TO": "Reply to this message",
      "DELETE": "Usuń",
      "CREATE_A_CANNED_RESPONSE": "Dodaj do gotowych odpowiedzi",
      "TRANSLATE": "Przetłumacz",
      "COPY_PERMALINK": "Kopiuj link do wiadomości",
      "LINK_COPIED": "URL wiadomości skopiowany do schowka",
      "FORWARD": "Przekaż",
      "FORWARD_ERROR": "Nie udało się przygotować przekazanej wiadomości",
      "DELETE_CONFIRMATION": {
        "TITLE": "Czy na pewno chcesz usunąć tę wiadomość?",
        "MESSAGE": "Tej akcji nie można cofnąć",
        "DELETE": "Usuń",
        "CANCEL": "Anuluj"
      }
    },
    "SIDEBAR": {
      "CONTACT": "Kontakt",
      "COPILOT": "Copilot"
    },
    "COMMENT_TREE": {
      "TITLE": "Wątek komentarzy",
      "EMPTY": "Brak komentarzy do wyświetlenia",
      "VIEW_TREE": "Zobacz wątek komentarzy"
    },
    "MESSAGE_EVENT": {
      "ACTIVITY": {
        "STATUS": {
          "RESOLVED": "Rozmowa została oznaczona przez {userName}",
          "CONTACT_RESOLVED": "Rozmowa została rozwiązana przez {contactName}",
          "OPEN": "Rozmowa została ponownie otwarta przez {userName}",
          "PENDING": "Rozmowa została oznaczona jako oczekująca przez {userName}",
          "SNOOZED": "Rozmowa została uśpiona przez {userName}",
          "AUTO_RESOLVED": "Rozmowa została oznaczona przez system jako rozwiązana z powodu {duration} dni bezczynności",
          "SYSTEM_AUTO_OPEN": "System otworzył ponownie rozmowę z powodu nowej wiadomości przychodzącej.",
          "AUTO_REOPENED": "System reopened the conversation after the snooze period ended.",
          "RESOLVED_WITHOUT_CSAT": "Rozmowa została oznaczona jako rozwiązana przez {userName} (bez CSAT)",
          "AUTO_RESOLVED_INACTIVE": "Rozmowa została oznaczona jako rozwiązana przez system z powodu {duration} godzin nieaktywności",
          "AUTO_RESOLVED_EMPTY": "Rozmowa została oznaczona jako rozwiązana przez system, ponieważ była pusta.",
          "BLOCKED_CONTACT_RESOLVED": "System rozwiązał rozmowę, ponieważ kontakt jest zablokowany.",
          "KAUFLAND_TICKET_CLOSED": "System rozwiązał rozmowę, ponieważ zgłoszenie zostało zamknięte na Kaufland."
        },
        "PRIORITY": {
          "ADDED": "{userName} ustawił priorytet na {newPriority}",
          "UPDATED": "{userName} zmienił priorytet z {oldPriority} na {newPriority}",
          "REMOVED": "{userName} usunął priorytet"
        },
        "ASSIGNEE": {
          "SELF_ASSIGNED": "{userName} przypisał się do tej rozmowy",
          "ASSIGNED": "Przypisane do {assigneeName} przez {userName}",
          "REMOVED": "Rozmowa nieprzypisana przez {userName}"
        },
        "TEAM": {
          "ASSIGNED": "Przydzielone do {teamName} przez {userName}",
          "ASSIGNED_WITH_ASSIGNEE": "Przypisano do {assigneeName} przez {teamName} przez {userName}",
          "REMOVED": "Usunięto przydzielenie do {teamName} przez {userName}"
        },
        "LABELS": {
          "ADDED": "{userName} dodał/a {labels}",
          "REMOVED": "{userName} usunął/a {labels}"
        },
        "SLA": {
          "ADDED": "{userName} dodał politykę SLA {slaName}",
          "REMOVED": "{userName} usunął politykę SLA {slaName}",
          "UPDATED": "{userName} updated SLA policy {slaName}"
        },
        "MUTED": "{userName} wyciszył/a rozmowę",
        "UNMUTED": "{userName} cofnął wyciszenie rozmowy",
        "CONTACT_BLOCKED": "{userName} zablokował(a) kontakt",
        "CONTACT_UNBLOCKED": "{userName} odblokował(a) kontakt",
        "AUTO_RESOLUTION_MESSAGE": "Rozwiązywanie konwersacji, ponieważ była nieaktywna przez pewien czas. Jeśli potrzebujesz dalszej pomocy, rozpocznij nową konwersację.",
        "DOMAIN_BLOCKED": "{userName} zablokował wszystkie kontakty dla podanej domeny",
        "DOMAIN_UNBLOCKED": "{userName} odblokował wszystkie kontakty dla podanej domeny",
        "MERGED": "{userName} scalił rozmowę #{sourceId} z tą rozmową",
        "MOVED": "{userName} przeniósł tę rozmowę ze skrzynki {sourceInboxName} do skrzynki {targetInboxName}",
        "MOVED_BY_ORDER": "Przeniesiono, ponieważ zamówienia kontaktu pochodzą tylko ze sklepu {storeName} (ostatnie zamówienie {orderId}), którego robot odpowiada w tej skrzynce.",
        "AUTOMATION_ACTION_SKIPPED_AUTO_REPLY": "Akcja wysłania wiadomości została pominięta dla tej automatycznej odpowiedzi",
        "AUTOMATION_SKIPPED_CONTACT_BLOCKED": "Automatyzacja została pominięta, ponieważ kontakt jest zablokowany",
        "AUTOMATION_MOVE_FAILED_INCOMPATIBLE_INBOX": "Automatyzacja \"{ruleName}\" nie mogła przenieść tej rozmowy ze skrzynki {sourceInboxName} do skrzynki {targetInboxName}, ponieważ skrzynki nie są zgodne.",
        "AUTOMATION_MOVE_FAILED_CONTACT_EMAIL_MISSING": "Automatyzacja \"{ruleName}\" nie mogła przenieść tej rozmowy ze skrzynki {sourceInboxName} do skrzynki {targetInboxName}, ponieważ kontakt nie ma adresu e-mail.",
        "AUTOMATION_RULE_DISABLED_PHONE_WITHOUT_SMS": "Automatyzacja \"{ruleName}\" nie mogła wysłać wiadomości: ta telefoniczna skrzynka odbiorcza nie może wysyłać SMS, ponieważ konto nie ma skrzynki odbiorczej SMS. Reguła została wyłączona, a administratorzy otrzymali e-mail.",
        "AUTOMATION_RULE_DISABLED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Automatyzacja \"{ruleName}\" nie mogła wysłać wiadomości: z tej skrzynki odbiorczej nie można wysyłać załączników przez SMS. Reguła została wyłączona, a administratorzy otrzymali e-mail.",
        "MACRO_ACTION_SKIPPED_PHONE_WITHOUT_SMS": "Makro \"{macroName}\" nie wysłało wiadomości: ta telefoniczna skrzynka odbiorcza nie może wysyłać SMS, ponieważ konto nie ma skrzynki odbiorczej SMS.",
        "MACRO_ACTION_SKIPPED_SMS_ATTACHMENTS_NOT_SUPPORTED": "Makro \"{macroName}\" nie wysłało wiadomości: z tej skrzynki odbiorczej nie można wysyłać załączników przez SMS.",
        "MACRO_ACTION_SKIPPED_PENDING_WITH_BOT": "Makro \"{macroName}\" nie wysłało wiadomości: tą konwersacją zajmuje się bot. Najpierw otwórz konwersację.",
        "MACRO_ACTION_SKIPPED_INBOX_DELETE_REQUESTED": "Makro \"{macroName}\" nie wysłało wiadomości: ta skrzynka odbiorcza jest oznaczona do usunięcia. Najpierw przenieś konwersację do innej skrzynki odbiorczej.",
        "AUTOMATION_NEW_CONVERSATION_SENT": "Automatyzacja \"{ruleName}\" wysłała e-mail na adres {contactEmail} w nowej rozmowie [#{conversationId}]({conversationPath}) w skrzynce {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_SOURCE": "Automatyzacja \"{ruleName}\" rozpoczęła tę rozmowę z powodu rozmowy [#{conversationId}]({conversationPath}) w skrzynce {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_EMAIL_MISSING": "Automatyzacja \"{ruleName}\" nie mogła wysłać wiadomości w nowej rozmowie w skrzynce {inboxName}, ponieważ kontakt nie ma adresu e-mail.",
        "AUTOMATION_NEW_CONVERSATION_SMS_SENT": "Automatyzacja \"{ruleName}\" wysłała SMS na numer {contactPhone} w nowej rozmowie [#{conversationId}]({conversationPath}) w skrzynce {inboxName}.",
        "AUTOMATION_NEW_CONVERSATION_FAILED_CONTACT_PHONE_MISSING": "Automatyzacja \"{ruleName}\" nie mogła wysłać SMS-a w nowej rozmowie w skrzynce {inboxName}, ponieważ kontakt nie ma numeru telefonu.",
        "AUTOMATION_RULE_TRIGGERED": "Reguła automatyzacji \"{ruleName}\" została uruchomiona",
        "AUTOMATION_SKIP_AUTO_PRIORITY": "Reguła automatyzacji \"{ruleName}\" wyłączyła automatyczny priorytet",
        "AUTOMATION_SKIP_AUTO_LABELING": "Reguła automatyzacji \"{ruleName}\" wyłączyła automatyczne etykietowanie",
        "AUTOMATION_STOP_PROCESSING_RULES": "Reguła automatyzacji \"{ruleName}\" zatrzymała dalsze przetwarzanie reguł",
        "AUTO_LABELING": {
          "REASONING": "Applied labels: {labels}\n{justification}"
        },
        "AUTO_PRIORITY": {
          "REASONING": "Updated priority: {reasoning}"
        },
        "SUMMARY": {
          "ROLE": {
            "AGENT": "Agent",
            "CUSTOMER": "Klient"
          }
        }
      },
      "VOICE": {
        "COPILOT": {
          "CALLED_EXTENSIONS": "Called extensions:",
          "CALL_COMPLETED": "Call completed",
          "EXTENSION_OUTCOMES": {
            "ANSWERED_ELSEWHERE": "odebrano gdzie indziej, dzwoniło {duration}",
            "NO_ANSWER": "bez odpowiedzi, dzwoniło {duration}",
            "REJECTED": "odrzucono, dzwoniło {duration}"
          },
          "EXTENSION_TYPES": {
            "IVR": "IVR",
            "OPERATOR": "Operator",
            "QUEUE": "Queue",
            "RING_GROUP": "Ring Group"
          },
          "INBOUND_CALL": "Inbound call from {number} to {did}",
          "IVR_HANDLED": "Handled by IVR",
          "IVR_LABEL_NOT_FOUND": "I wanted to add label {name}, but it does not exist, please check the configuration.",
          "CALL_MISSED": "Call missed",
          "CALL_NO_ANSWER": "No answer",
          "RESOLVED_AFTER_FAILED_CALLBACKS": "Rozwiązano automatycznie po nieudanych oddzwonieniach (liczba: {count})",
          "OUTBOUND_CALL": "Outbound call made by {agentName} from {did} to {number}",
          "SUMMARY_NOT_AVAILABLE": "Unable to generate summary.",
          "RECORDING_DELETED": "Nagranie rozmowy zostało usunięte przez użytkownika {name}, {date}"
        }
      }
    }
  },
  "EMAIL_TRANSCRIPT": {
    "TITLE": "Wyślij transkrypt wiadomości",
    "DESC": "Wyślij kopię transkryptu rozmowy na podany adres e-mail",
    "SUBMIT": "Prześlij",
    "CANCEL": "Anuluj",
    "SEND_EMAIL_SUCCESS": "Transkrypt rozmowy został pomyślnie wysłany",
    "SEND_EMAIL_ERROR": "Wystąpił błąd, spróbuj ponownie",
    "FORM": {
      "SEND_TO_CONTACT": "Wyślij transkrypt do klienta",
      "SEND_TO_AGENT": "Wyślij transkrypt do przypisanego agenta",
      "SEND_TO_OTHER_EMAIL_ADDRESS": "Wyślij transkrypt na inny adres e-mail",
      "EMAIL": {
        "PLACEHOLDER": "Wprowadź adres e-mail",
        "ERROR": "Wprowadź poprawny adres e-mail"
      }
    }
  },
  "ONBOARDING": {
    "TITLE": "Cześć 👋, Witamy w {installationName}!",
    "DESCRIPTION": "Dziękujemy za rejestrację. Chcemy, abyś jak najlepiej skorzystał z {installationName}. Oto kilka rzeczy, które możesz spróbować, aby zapewnić sobie jak najlepsze doświadczenie z {installationName}.",
    "GREETING_MORNING": "👋 Good morning, {name}. Welcome to {installationName}.",
    "GREETING_AFTERNOON": "👋 Good afternoon, {name}. Welcome to {installationName}.",
    "GREETING_EVENING": "👋 Good evening, {name}. Welcome to {installationName}.",
    "READ_LATEST_UPDATES": "Przeczytaj najnowsze aktualizacje",
    "ALL_CONVERSATION": {
      "TITLE": "Wszystkie Twoje konwersacje w jednym miejscu",
      "DESCRIPTION": "Zobacz wszystkie konwersacje z klientami w jednym miejscu. Możesz filtrować konwersacje według kanału, z którego pochodzą, etykiet lub statusu.",
      "NEW_LINK": "Kliknij tutaj, aby utworzyć nową skrzynkę odbiorczą"
    },
    "TEAM_MEMBERS": {
      "TITLE": "Zaproszenie członków zespołu",
      "DESCRIPTION": "Ponieważ przygotowujesz się do rozmowy z klientem, zaproś członków zespołu, aby pomogli Ci. Możesz zaprosić członków zespołu, dodając ich adresy e-mail do listy agentów.",
      "NEW_LINK": "Kliknij tutaj, aby zaprosić nowego członka zespołu"
    },
    "LABELS": {
      "TITLE": "Organizuj konwersacje za pomocą etykiet",
      "DESCRIPTION": "Etykiety ułatwiają kategoryzację konwersacji. Utwórz etykiety, takie jak #zapytanie-o-wsparcie, #pytanie-o-fakturę itp., aby później łatwo z nich korzystać w trakcie rozmowy.",
      "NEW_LINK": "Kliknij tutaj, aby utworzyć nową etykietę"
    },
    "CANNED_RESPONSES": {
      "TITLE": "Create canned responses",
      "DESCRIPTION": "Pre-written quick reply templates help you quickly respond to a conversation. Agents can type the '/' character followed by the shortcode to insert a response.",
      "NEW_LINK": "Click here to create a canned response"
    }
  },
  "CONVERSATION_SIDEBAR": {
    "ASSIGNEE_LABEL": "Przypisany Agent",
    "SELF_ASSIGN": "Przypisz do mnie",
    "TEAM_LABEL": "Przypisany zespół",
    "SELECT": {
      "PLACEHOLDER": "Brak"
    },
    "ACCORDION": {
      "CUSTOM_DATA_PROVIDER": "Dane niestandardowe",
      "ORDER_HISTORY": "Historia zamówień",
      "CONTACT_DETAILS": "Dane kontaktowe",
      "CONVERSATION_ACTIONS": "Akcje konwersacji",
      "CONVERSATION_LABELS": "Etykiety konwersacji",
      "CONVERSATION_INFO": "Informacje o konwersacji",
      "CONTACT_ATTRIBUTES": "Atrybuty kontaktu",
      "PREVIOUS_CONVERSATION": "Poprzednie konwersacje",
      "MACROS": "Makra",
      "RETINO_TICKETS": "Zgłoszenia Retino",
      "SHOPIFY_ORDERS": "Shopify Orders"
    },
    "SHOPIFY": {
      "ORDER_ID": "Order #{id}",
      "ERROR": "Error loading orders",
      "NO_SHOPIFY_ORDERS": "No orders found",
      "FINANCIAL_STATUS": {
        "PENDING": "Oczekujące",
        "AUTHORIZED": "Authorized",
        "PARTIALLY_PAID": "Partially Paid",
        "PAID": "Paid",
        "PARTIALLY_REFUNDED": "Partially Refunded",
        "REFUNDED": "Refunded",
        "VOIDED": "Voided"
      },
      "FULFILLMENT_STATUS": {
        "FULFILLED": "Fulfilled",
        "PARTIALLY_FULFILLED": "Partially Fulfilled",
        "UNFULFILLED": "Unfulfilled"
      }
    }
  },
  "CONVERSATION_CUSTOM_DATA_PROVIDER": {
    "NO_RECORDS_FOUND": "Nie znaleziono danych",
    "LOAD_ERROR": "Nie udało się załadować danych. Spróbuj ponownie później."
  },
  "CONVERSATION_RETINO_TICKETS": {
    "LOAD_MORE": "Załaduj więcej",
    "NO_RECORDS_FOUND": "Nie znaleziono zgłoszeń",
    "LOAD_ERROR": "Nie można załadować zgłoszeń z {hookName}. Spróbuj ponownie później.",
    "NOT_SEARCHABLE": "Adres e-mail kontaktu nie jest ustawiony.",
    "TIMES": "&times;"
  },
  "CONVERSATION_ORDER_HISTORY": {
    "LOADING": "Ładowanie...",
    "NO_ORDERS": "Nie znaleziono zamówień",
    "NOT_AVAILABLE": "Dane klienta niedostępne",
    "EXPAND": "Otwórz profil klienta",
    "MORE_ITEMS": "+ {count} pozycji",
    "EXPEDITION_STATUS": "Status ekspedycji",
    "OPEN_DETAIL": "otwórz szczegóły",
    "COPY_ORDER_ID": "Numer zamówienia",
    "EXTERNAL_ID": "ID zewnętrzne",
    "PAYMENT_TYPE": "Sposób płatności",
    "PAYMENT_DATE": "Data płatności",
    "DELIVERY_PROVIDER": "Przewoźnik",
    "EXPECTED_DATE_OF_DELIVERY": "Przewidywana dostawa",
    "DATE_OF_DELIVERY": "Dostarczono",
    "EXPEDITION_DATE": "Data wysyłki",
    "INTERNAL_NOTE": "Notatka sklepu",
    "PACKAGE_NUMBER": "Przesyłka"
  },
  "CONVERSATION_CUSTOM_ATTRIBUTES": {
    "ADD_BUTTON_TEXT": "Utwórz atrybut",
    "NO_RECORDS_FOUND": "Brak wyników",
    "UPDATE": {
      "SUCCESS": "Atrybut zaktualizowany pomyślnie",
      "ERROR": "Nie można zaktualizować atrybutu. Spróbuj ponownie później"
    },
    "ADD": {
      "TITLE": "Dodaj",
      "SUCCESS": "Atrybut dodany pomyślnie",
      "ERROR": "Nie można dodać atrybutu. Spróbuj ponownie później"
    },
    "DELETE": {
      "SUCCESS": "Atrybut usunięty pomyślnie",
      "ERROR": "Nie można usunąć atrybutu. Spróbuj ponownie później"
    },
    "ATTRIBUTE_SELECT": {
      "TITLE": "Dodaj atrybuty",
      "PLACEHOLDER": "Wyszukaj atrybuty",
      "NO_RESULT": "Brak wyników"
    }
  },
  "EMAIL_HEADER": {
    "FROM": "Od",
    "TO": "Do",
    "BCC": "Bcc",
    "CC": "Cc",
    "SUBJECT": "Temat"
  },
  "CONVERSATION_PARTICIPANTS": {
    "SIDEBAR_MENU_TITLE": "Uczestniczący",
    "SIDEBAR_TITLE": "Uczestnicy konwersacji",
    "NO_RECORDS_FOUND": "Nie znaleziono rekordów",
    "ADD_PARTICIPANTS": "Wybierz uczestników",
    "REMANING_PARTICIPANTS_TEXT": "+{count} innych",
    "REMANING_PARTICIPANT_TEXT": "+{count} inna osoba",
    "TOTAL_PARTICIPANTS_TEXT": "Bierze w nich udział {count} osób.",
    "TOTAL_PARTICIPANT_TEXT": "Bierze w nich udział {count} osoba.",
    "NO_PARTICIPANTS_TEXT": "Nikt nie bierze udziału!",
    "WATCH_CONVERSATION": "Dołącz do konwersacji",
    "YOU_ARE_WATCHING": "Bierzesz udział",
    "API": {
      "ERROR_MESSAGE": "Nie można zaktualizować, spróbuj ponownie!",
      "SUCCESS_MESSAGE": "Uczestnicy zaktualizowani!"
    },
    "SEARCH_PLACEHOLDER": "Search"
  },
  "TRANSLATE_MODAL": {
    "TITLE": "Wyświetl przetłumaczone treści",
    "DESC": "Możesz zobaczyć przetłumaczone treści w każdym języku.",
    "ORIGINAL_CONTENT": "Oryginalna treść",
    "TRANSLATED_CONTENT": "Przetłumaczona treść",
    "NO_TRANSLATIONS_AVAILABLE": "Brak dostępnych tłumaczeń dla tej treści"
  },
  "TYPING": {
    "ONE": "{user} is typing",
    "TWO": "{user} and {secondUser} are typing",
    "MULTIPLE": "{user} and {count} others are typing",
    "IMAGE_ALT": "Ktoś pisze"
  },
  "READING": {
    "ONE": "{user} czyta to zgłoszenie",
    "TWO": "{user} i {secondUser} czytają to zgłoszenie",
    "MULTIPLE": "{user} i {count} innych czyta to zgłoszenie"
  },
  "COPILOT": {
    "TRY_THESE_PROMPTS": "Try these prompts"
  },
  "MOVE_CONVERSATION": {
    "TITLE": "Przenieś rozmowę",
    "DESCRIPTION": "Przenieś tę rozmowę do innej skrzynki e-mail.",
    "SOURCE": {
      "TITLE": "Rozmowa",
      "ID_LABEL": "ID rozmowy"
    },
    "TARGET": {
      "TITLE": "Skrzynka docelowa",
      "PLACEHOLDER": "Wybierz skrzynkę e-mail",
      "NO_RESULTS": "Brak innych dostępnych skrzynek e-mail",
      "ERROR": "Wybierz skrzynkę docelową"
    },
    "SUBMIT": "Przenieś rozmowę",
    "CANCEL": "Anuluj",
    "SUCCESS_MESSAGE": "Rozmowa została pomyślnie przeniesiona",
    "ERROR_MESSAGE": "Nie można przenieść rozmowy. Spróbuj ponownie."
  },
  "MERGE": {
    "TITLE": "Scal rozmowy",
    "DESCRIPTION": "Scal tę rozmowę z inną rozmową. Wszystkie wiadomości z tej rozmowy zostaną przeniesione do rozmowy docelowej, a ta rozmowa zostanie usunięta.",
    "SOURCE": {
      "TITLE": "Rozmowa źródłowa (zostanie usunięta)",
      "ID_LABEL": "ID rozmowy"
    },
    "TARGET": {
      "TITLE": "Rozmowa docelowa",
      "PLACEHOLDER": "Wpisz ID rozmowy, aby wyszukać (np. 123)",
      "HELP": "Wprowadź ID rozmowy, do której mają być scalone wszystkie wiadomości.",
      "ERROR": "Wybierz rozmowę docelową"
    },
    "WARNING": "Uwaga: tej operacji nie można cofnąć. Wszystkie wiadomości zostaną przeniesione do rozmowy docelowej, a ta rozmowa zostanie trwale usunięta.",
    "SUBMIT": "Scal rozmowy",
    "CANCEL": "Anuluj",
    "SUCCESS_MESSAGE": "Rozmowa została pomyślnie scalona",
    "ERROR_MESSAGE": "Nie można scalić rozmów. Sprawdź rozmowę docelową i spróbuj ponownie.",
    "SEARCH": {
      "NO_RESULTS": "Nie znaleziono rozmowy o tym ID",
      "ERROR_MESSAGE": "Nie można przeszukać rozmów. Spróbuj ponownie."
    },
    "CONFIRM": {
      "TITLE": "Potwierdź scalanie",
      "DESCRIPTION": "Czy na pewno chcesz scalić tę rozmowę? Tej operacji nie można cofnąć.",
      "YES": "Tak, scal",
      "CANCEL": "Anuluj"
    }
  },
  "GALLERY_VIEW": {
    "ERROR_DOWNLOADING": "Unable to download attachment. Please try again"
  }
}
